import { render } from "./Index.vue?vue&type=template&id=7fcc8666&scoped=true&bindings={\"site\":\"props\",\"slug\":\"props\",\"transitionClass\":\"data\",\"version\":\"data\",\"questionsConfig\":\"options\",\"showPrograms\":\"options\",\"selectProgram\":\"options\",\"listQuestions\":\"options\"}"
import script from "./Index.vue?vue&type=script&lang=js"
export * from "./Index.vue?vue&type=script&lang=js"

import "./Index.vue?vue&type=style&index=0&id=7fcc8666&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-7fcc8666"

export default script